export default "__VITE_ASSET__4bc5811f__"